export enum UrlParameter {
  workspace = 'workspace',
  tool = 'tool',
  layer = 'layer',
  id = 'id',
  guid = 'guid',
  aoid = 'aoid',
  egrid = 'egrid',
  selection = 'sel',
}
